document.addEventListener('DOMContentLoaded', function() {
  // Handle quantity controls for product-revgo-header specifically
  const quantityInput = document.querySelector('.product-revgo-header .product-qty');
  const minusButton = document.querySelector('.product-revgo-header .quantity-count--minus');
  const plusButton = document.querySelector('.product-revgo-header .quantity-count--add');
  
  if (!quantityInput || !minusButton || !plusButton) return;
  
  function updateQuantity(newValue) {
    const value = Math.max(1, parseInt(newValue) || 1);
    quantityInput.value = value;
    
    // Update button states
    minusButton.disabled = value <= 1;
  }
  
  // Handle minus button click
  minusButton.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    const currentValue = parseInt(quantityInput.value) || 1;
    if (currentValue > 1) {
      updateQuantity(currentValue - 1);
    }
  });
  
  // Handle plus button click
  plusButton.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    const currentValue = parseInt(quantityInput.value) || 1;
    updateQuantity(currentValue + 1);
  });
  
  // Handle direct input changes
  quantityInput.addEventListener('input', function(e) {
    updateQuantity(e.target.value);
  });
  
  // Handle keyboard input (arrow keys)
  quantityInput.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowUp') {
      e.preventDefault();
      const currentValue = parseInt(quantityInput.value) || 1;
      updateQuantity(currentValue + 1);
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      const currentValue = parseInt(quantityInput.value) || 1;
      if (currentValue > 1) {
        updateQuantity(currentValue - 1);
      }
    }
  });
  
  // Initialize button state
  updateQuantity(quantityInput.value);
});
